import './DynamicButton.scss';

// Importar iconos SVG
import CameraIcon from '../../assets/imgs/vehicleIcon.svg';
import LoadingIcon from '../../assets/imgs/loader.gif';
import ViewIcon from '../../assets/imgs/view-icon.svg';
import InfoIcon from '../../assets/imgs/info-icon.svg';

export type ButtonType = 'camera' | 'loading' | 'view' | 'info';

interface DynamicButtonProps {
  type: ButtonType;
  onClick?: () => void;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  iconSize?: string; // Nueva prop para tamaño personalizado del icono
  className?: string;
  children?: React.ReactNode;
  loading?: boolean; // Para mostrar estado de carga
}

const DynamicButton: React.FC<DynamicButtonProps> = ({
  type,
  onClick,
  disabled = false,
  size = 'medium',
  iconSize,
  className = '',
  children,
  loading = false,
}) => {
  // Configuración de iconos y colores por tipo
  const buttonConfig = {
    camera: {
      icon: CameraIcon,
      color: '#007bff',
      hoverColor: '#0056b3',
      backgroundColor: '#E3F2FD',
      hoverBackgroundColor: '#BBDEFB',
    },
    loading: {
      icon: LoadingIcon,
      color: '#FF9800',
      hoverColor: '#F57C00',
      backgroundColor: '#F3F8FB',
      hoverBackgroundColor: '#FFE0B2',
    },
    view: {
      icon: ViewIcon,
      color: '#4CAF50',
      hoverColor: '#388E3C',
      backgroundColor: '#F3FBF9',
      hoverBackgroundColor: '#C8E6C9',
    },
    info: {
      icon: InfoIcon,
      color: '#9C27B0',
      hoverColor: '#7B1FA2',
      backgroundColor: '#FBF1E6',
      hoverBackgroundColor: '#E1BEE7',
    },
  };

  const config = buttonConfig[type];
  const IconComponent = config.icon;

  // Tamaños del botón
  const sizeConfig = {
    small: {
      padding: '8px 12px',
      fontSize: '12px',
      iconSize: '24px',

    },
    medium: {
      padding: '12px 16px',
      fontSize: '14px',
      iconSize: '50px',

    },
    large: {
      padding: '16px 24px',
      fontSize: '16px',
      iconSize: '60px',
    },
  };

  const currentSize = sizeConfig[size];
  
  // Usar iconSize personalizado si se proporciona, sino usar el tamaño por defecto
  const finalIconSize = iconSize || currentSize.iconSize;

  return (
    <button
      className={`dynamic-button dynamic-button--${type} dynamic-button--${size} ${className}`}
      onClick={onClick}
      disabled={disabled || loading}
      style={{
        '--button-color': config.color,
        '--button-background': config.backgroundColor,
        '--button-hover-background': config.hoverBackgroundColor,
        '--button-padding': currentSize.padding,
        '--button-font-size': currentSize.fontSize,
        '--button-icon-size': finalIconSize,
      } as React.CSSProperties}
    >
      <div className="dynamic-button__content">
        <div className="dynamic-button__icon">
          <img 
            src={IconComponent} 
            alt={`${type} icon`}
            className={`dynamic-button__icon-img ${loading ? 'dynamic-button__icon-img--spinning' : ''}`}
          />
        </div>
        {children && (
          <span className="dynamic-button__text">
            {children}
          </span>
        )}
      </div>
    </button>
  );
};

export default DynamicButton;
